/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CourseRequest } from '../../models/course-request';
import { RequestResult } from '../../models/request-result';

export interface ApiRequestCourseVerifyPost$Params {
      body?: CourseRequest
}

export function apiRequestCourseVerifyPost(http: HttpClient, rootUrl: string, params?: ApiRequestCourseVerifyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<RequestResult>> {
  const rb = new RequestBuilder(rootUrl, apiRequestCourseVerifyPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RequestResult>;
    })
  );
}

apiRequestCourseVerifyPost.PATH = '/api/Request/Course/Verify';
